module.exports = __webpack_public_path__ + "static/media/notification2.47419f5e.svg";